<mat-toolbar
  class="topbar horizontal-topbar gap-1 border-b border-border shadow-none!"
>
  <div class="container px-0! lg:px-6! gap-1">
    <div class="hidden md:flex">
      <app-branding></app-branding>
    </div>

    <!-- Mobile Menu -->
    <button
      title="Toggle mobile nav"
      mat-icon-button
      (click)="toggleMobileNav.emit()"
      class="flex items-center justify-center lg:hidden! mx-1"
    >
      <i
        class="iconify text-xl! flex"
        data-icon="solar:hamburger-menu-line-duotone"
      ></i>
    </button>

    <div class="hidden lg:flex">
      <mat-form-field appearance="outline" class="hide-hint">
        <input matInput placeholder="Search..." />
        <mat-icon class="flex items-center justify-center" matSuffix>
          <i
            class="iconify text-xl! flex"
            data-icon="solar:magnifer-line-duotone"
          ></i>
        </mat-icon>
      </mat-form-field>
    </div>

    <span class="flex-1"></span>

    <!-- --------------------------------------------------------------- -->
    <!--  Search -->
    <!-- --------------------------------------------------------------- -->
    <button
      title="open dialog"
      mat-icon-button
      (click)="openDialog()"
      class="flex lg:hidden! items-center justify-center"
    >
      <i class="iconify text-xl! flex" data-icon="solar:magnifer-outline"></i>
    </button>

    @if (options.theme == "light") {
      <button
        mat-icon-button
        aria-label="lightdark"
        class="flex justify-center"
        (click)="setlightDark('dark')"
      >
        <i-tabler class="flex text-xl!" [name]="'moon'"></i-tabler>
      </button>
    } @else {
      <button
        mat-icon-button
        aria-label="lightdark"
        class="flex justify-center"
        (click)="setlightDark('light')"
      >
        <i-tabler class="flex text-xl!" [name]="'sun'"></i-tabler>
      </button>
    }

    <!-- --------------------------------------------------------------- -->
    <!-- langugage Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button
      title="Langue"
      [matMenuTriggerFor]="flags"
      mat-icon-button
      class="hidden! lg:flex!"
    >
      <img
        title="flag select"
        [src]="selectedLanguage.icon"
        class="rounded-full object-cover"
      />
    </button>
    <mat-menu #flags="matMenu" class="cardWithShadow" xPosition="before">
      @for (lang of languages; track lang.icon) {
        <button mat-menu-item (click)="changeLanguage(lang)">
          <div class="flex gap-2 items-center">
            <img
              title="flag"
              [src]="lang.icon"
              class="rounded-full object-cover size-5!"
            />
            <span class="text-sm">{{ lang.language }}</span>
          </div>
        </button>
      }
    </mat-menu>

    <!-- --------------------------------------------------------------- -->
    <!-- Shopping Cart -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-icon-button
      (click)="toggleShoppingCartNav.emit()"
      class="flex justify-center items-center relative"
    >
      <i
        class="iconify text-xl! flex"
        data-icon="solar:cart-large-minimalistic-line-duotone"
      ></i>
      <div
        class="bg-error text-white text-[10px] h-4 w-4 rounded-full leading-3 flex items-center justify-center absolute right-0.5 top-px rtl:right-auto rtl:left-0.5"
      >
        0
      </div>
    </button>

    <!-- --------------------------------------------------------------- -->
    <!-- Sélecteur de langue Dinki -->
    <!-- --------------------------------------------------------------- -->
    <app-language-switcher
      class="hidden! lg:inline-flex!"
    ></app-language-switcher>

    <!-- --------------------------------------------------------------- -->
    <!-- Notification Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="notificationmenu"
      aria-label="Notifications"
      class="hidden! lg:flex! items-center justify-center"
    >
      <i class="iconify text-xl! flex" data-icon="solar:bell-line-duotone"></i>
      <div
        class="bg-error text-white text-[10px] h-4 w-4 rounded-full leading-3 flex items-center justify-center absolute right-0.5 top-px rtl:right-auto rtl:left-0.5"
      >
        6
      </div>
    </button>
    <mat-menu
      #notificationmenu="matMenu"
      class="topbar-dd cardWithShadow"
      xPosition="before"
    >
      <div class="flex items-center justify-between px-7.5 py-4">
        <h6 class="text-lg font-semibold">Notifications</h6>
        <span
          class="bg-primary text-white px-2 py-1 font-medium rounded-xl text-xs"
          >5 new</span
        >
      </div>

      @for (notification of notifications; track notification.title) {
        <button mat-menu-item class="px-7.5! py-3!">
          <div class="flex gap-4 items-center text-dark">
            <span
              class="shrink-0 text-{{ notification.color }} bg-light-{{
                notification.color
              }} rounded-full size-12! flex items-center justify-center"
            >
              <i
                class="iconify text-xl! flex"
                [attr.data-icon]="notification.icon"
              ></i>
            </span>
            <div class="w-full">
              <div class="flex items-center justify-between w-full">
                <h5 class="text-sm font-semibold">
                  {{ notification.title }}
                </h5>
                <span class="block text-xs"> {{ notification.time }}</span>
              </div>
              <span class="block text-truncate text-xs">{{
                notification.subtitle
              }}</span>
            </div>
          </div>
        </button>
      }

      <div class="py-3 px-7.5">
        <button mat-flat-button color="primary" class="w-full">
          See all Notifications
        </button>
      </div>
    </mat-menu>

    <!-- --------------------------------------------------------------- -->
    <!-- Collpase bar -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-icon-button
      (click)="toggleCollpase()"
      class="flex lg:hidden! justify-center"
    >
      <i class="iconify text-xl! flex" data-icon="solar:sort-outline"></i>
    </button>
    @if (isCollapse) {
      <div class="header-collpase py-2.5 px-4">
        <div class="flex justify-center gap-2">
          <!-- --------------------------------------------------------------- -->
          <!-- langugage Dropdown -->
          <!-- --------------------------------------------------------------- -->
          <button [matMenuTriggerFor]="flags" mat-icon-button>
            <img
              [src]="selectedLanguage.icon"
              class="rounded-full object-cover"
            />
          </button>

          <!-- --------------------------------------------------------------- -->
          <!-- Notification Dropdown -->
          <!-- --------------------------------------------------------------- -->
          <button
            class="relative flex items-center justify-center"
            mat-icon-button
            [matMenuTriggerFor]="notificationmenu"
            aria-label="Notifications"
          >
            <i class="iconify flex" data-icon="solar:bell-line-duotone"></i>
            <div
              class="bg-error text-white text-[10px] h-4 w-4 rounded-full leading-3 flex items-center justify-center absolute right-0.5 top-px rtl:right-auto rtl:left-0.5"
            >
              6
            </div>
          </button>

          <!-- --------------------------------------------------------------- -->
          <!-- Inbox Dropdown -->
          <!-- --------------------------------------------------------------- -->
          <button
            class="relative flex items-center justify-center"
            mat-icon-button
            [matMenuTriggerFor]="inboxmenu"
            aria-label="Inbox"
          >
            <i
              class="iconify flex"
              data-icon="solar:settings-minimalistic-line-duotone"
            ></i>
            <div
              class="bg-primary text-white text-[10px] h-4 w-4 rounded-full leading-3 flex items-center justify-center absolute right-0.5 top-px rtl:right-auto rtl:left-0.5"
            >
              3
            </div>
          </button>

          <!-- --------------------------------------------------------------- -->
          <!-- Profile Dropdown -->
          <!-- --------------------------------------------------------------- -->
          <button
            mat-icon-button
            extended
            [matMenuTriggerFor]="profilemenu"
            aria-label="Notifications"
            class="relative flex items-center justify-center p-0! profile-btn-dd"
          >
            <img
              src="/assets/images/profile/user-1.webp"
              class="rounded-full size-9! object-cover profile-dd flex items-center justify-center"
              width="36"
              height="36"
            />
          </button>
        </div>
      </div>
    }

    <!-- --------------------------------------------------------------- -->
    <!-- Inbox Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="inboxmenu"
      aria-label="inbox"
      class="hidden! lg:flex! items-center justify-center"
    >
      <i
        class="iconify text-xl! flex"
        data-icon="solar:settings-minimalistic-line-duotone"
      ></i>
    </button>
    <mat-menu
      #inboxmenu="matMenu"
      class="topbar-dd cardWithShadow"
      xPosition="before"
    >
      <div class="flex items-center justify-between px-7.5 py-4">
        <h6 class="text-lg font-semibold">Inbox</h6>
        <span
          class="bg-warning text-white px-2 py-1 font-medium rounded-xl text-xs"
          >3 new</span
        >
      </div>

      @for (inbox of inbox; track inbox.title) {
        <button mat-menu-item class="px-7.5! py-3!">
          <div class="flex gap-4 items-center text-dark">
            <span
              class="relative shrink-0 rounded-full size-12! flex items-center justify-center"
            >
              <img
                class="rounded-full size-12!"
                [src]="inbox.imagePath"
                width="48"
                height="48"
                alt="users"
              />
              <div
                matBadge=""
                matBadgeOverlap="false"
                class="{{
                  inbox.bgcolor
                }} demo-section inbox-badge size-2! block absolute! top-0.5 right-0.5 rounded-full"
              ></div>
            </span>
            <div class="w-full">
              <div class="flex items-center justify-between w-full">
                <h5 class="text-sm font-semibold">
                  {{ inbox.title }}
                </h5>
                <span class="block text-xs"> {{ inbox.time }}</span>
              </div>
              <span class="block text-truncate text-xs">{{
                inbox.subtitle
              }}</span>
            </div>
          </div>
        </button>
      }

      <div class="py-3 px-7.5">
        <button mat-stroked-button color="primary" class="w-full">
          See All Messages
        </button>
      </div>
    </mat-menu>

    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="profilemenu"
      aria-label="Profile"
      class="profile-btn hidden! lg:flex! justify-center items-center p-0!"
    >
      <img
        src="/assets/images/profile/user-1.webp"
        class="rounded-full object-cover size-9! profile-dd"
        width="36"
      />
    </button>
    <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
      <div class="flex flex-col items-center gap-6 py-6 border-b border-border">
        <img
          src="/assets/images/profile/user-1.webp"
          class="rounded-full"
          width="80"
          height="80"
        />
        <div class="flex flex-col items-center gap-1">
          <h6 class="text-lg font-semibold">Cameron</h6>
          <p class="m-0 flex items-center gap-1 text-muted">
            <i
              class="iconify text-lg flex"
              data-icon="solar:mailbox-line-duotone"
            ></i>
            <a class="text-muted" href="mailto:info@nicedash.com"
              >info@nicedash.com</a
            >
          </p>
        </div>
      </div>
      <div class="px-3 py-6">
        @for (profile of profiledd; track profile.title) {
          <a
            class="mat-list-item py-2 px-4 flex items-center gap-2 text-muted rounded-lg"
            [routerLink]="[profile.link]"
          >
            <i class="iconify text-xl" [attr.data-icon]="profile.icon"></i>
            {{ profile.title }}

            @if (profile.new) {
              <span
                class="bg-light-primary text-primary rounded-lg px-2 py-0.5 font-medium text-xs"
                >5</span
              >
            }
          </a>
        }
      </div>
      <div class="px-3 py-6">
        <div class="flex items-center flex-col gap-4">
          <img
            src="/assets/images/backgrounds/first-steps.webp"
            alt="first-steps"
            width="80"
            class="img-fluid mb-3"
          />
          <div class="flex flex-col items-center">
            <h5 class="text-lg">Grab Nice Dash</h5>
            <p class="m-0 text-muted">Customize your dashboard</p>
          </div>
          <a matButton="filled" href="authentication/login" class="bg-secondary"
            >Log out</a
          >
        </div>
      </div>
    </mat-menu>
  </div>
</mat-toolbar>
